export default __webpack_public_path__ + "static/media/icon512.8e113fbf.svg";